import { render } from "./HostsItem.vue?vue&type=template&id=659a304f"
import script from "./HostsItem.vue?vue&type=script&lang=js"
export * from "./HostsItem.vue?vue&type=script&lang=js"

import "./HostsItem.vue?vue&type=style&index=0&id=659a304f&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__